import { useEffect, useRef } from 'react';
import { useAuthStore, useUnauthorizedHandler } from '@features/auth/hooks/useAuthStore';

interface AuthProviderProps {
  children: React.ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { checkSession } = useAuthStore();
  const initialized = useRef(false);

  // Auto-logout when any API call returns 401
  useUnauthorizedHandler();

  useEffect(() => {
    // Only call checkSession once on mount — prevents double-fire during
    // React strict mode and Vite HMR.
    if (!initialized.current) {
      initialized.current = true;
      checkSession();
    }
  }, [checkSession]);

  return <>{children}</>;
}
